import { render, staticRenderFns } from "./technician.vue?vue&type=template&id=6deb2b24&scoped=true&"
import script from "./technician.vue?vue&type=script&lang=js&"
export * from "./technician.vue?vue&type=script&lang=js&"
import style0 from "./technician.vue?vue&type=style&index=0&lang=css&"
import style1 from "./technician.vue?vue&type=style&index=1&id=6deb2b24&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6deb2b24",
  null
  
)

export default component.exports